import $ from 'jquery';

const slideShowElement = $('.slideshow');


let rtn = {};

/**
 * @brief [brief description]
 * @details [long description]
 * @return [description]
 */
const animate = function () {

    slideShowElement.each(function () {

        const el = $(this);
        const active = el.find('.active');
        const next = (el.find('.active').next().length > 0) ? el.find('.active').next() : el.find('.slide').first();
        



        next.css('z-index', 2);

        active.fadeOut({
            duration: 1000,
            easing: 'swing',
            done: function () {
                active.css('z-index', 1).show().removeClass('active');
                next.css('z-index', 3).addClass('active');
            }

        });

        /*active.fadeOut(2000, function() {
            active.css('z-index', 1).show().removeClass('active');
            next.css('z-index', 3).addClass('active');
        });
        */
    });



}





rtn.init = () => {

    

    if (slideShowElement.length > 0) {
        setInterval(animate, 7000);
    }

};


module.exports = rtn;



// WEBPACK FOOTER //
// ./js/service/cross-fade-slideshow.js